import { render, staticRenderFns } from "./AbilityWidget.vue?vue&type=template&id=751cdaac&scoped=true"
import script from "./AbilityWidget.vue?vue&type=script&lang=js"
export * from "./AbilityWidget.vue?vue&type=script&lang=js"
import style0 from "./AbilityWidget.vue?vue&type=style&index=0&id=751cdaac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751cdaac",
  null
  
)

export default component.exports